import {initViewComponentsExamples} from "../../development/view-components/examples";
import {initGridsExamples} from "../../development/grids/examples";

function registerDevelopmentComponents(components) {
	/**
	 * Development
	 */

	components['development.view-components.examples'] = {
		action: initViewComponentsExamples,
	};

	components['development.grids.examples'] = {
		action: initGridsExamples,
	};

	/**
	 * Custom Components
	 */
}

export {registerDevelopmentComponents}
